import { element as ngElement } from 'angular';
import * as html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf';
export var PdfGeneratorDirective = [
    '$timeout',
    '$window',
    '$location',
    'searchStateService',
    function ($timeout, $window, $location, searchStateService) {
        if (!$window.Promise) {
            $window.Promise = $window.ES6Promise;
        }
        var overlayHtml = "\n      <div class=\"lightbox__container\">\n        <div class=\"lightbox__overlay\"></div>\n        <div class=\"lightbox__preloader content-preloader content-preloader--40\"></div>\n      </div>\n    ";
        var getPdfFileName = function (ngLocation) {
            var fallbackName = 'GN compatibility guide.pdf';
            var prepareNames = function (names) { return names.replace(/,/g, ', '); };
            var _a = ngLocation.search(), products = _a.products, thirdPartyProducts = _a.thirdPartyProducts;
            var path = ngLocation.path();
            if (path.includes('/gallery')) {
                return thirdPartyProducts ? prepareNames(thirdPartyProducts) + ".pdf" : fallbackName;
            }
            if (path.includes('/solutions')) {
                return prepareNames(products) + " + " + prepareNames(thirdPartyProducts) + ".pdf";
            }
            return fallbackName;
        };
        var generatePdf = function ($scope) {
            searchStateService.maximizeSolutionsLimit();
            var overlay = ngElement(overlayHtml);
            $scope.$applyAsync(function () {
                $timeout(function () {
                    if (overlay.parent().length > 0) {
                        return;
                    }
                    ngElement('.master__container').append(overlay);
                    ngElement('body').addClass('pdf-generation');
                    ngElement('html, body').scrollTop(0);
                    var lazyImages = ngElement('img[lazy-img]');
                    lazyImages.each(function (index, element) {
                        var lazyImgAttributeValue = element.getAttribute('lazy-img');
                        if (element.src === lazyImgAttributeValue) {
                            return;
                        }
                        element.src = lazyImgAttributeValue;
                    });
                    try {
                        var source = ngElement('.page-section.ng-scope')[0];
                        var options = {
                            backgroundColor: '#fff',
                            onrendered: function (canvas) {
                                var imgData = canvas.toDataURL('image/png');
                                var imgWidth = 210;
                                var pageHeight = 295;
                                var imgHeight = (canvas.height * imgWidth) / canvas.width;
                                var doc = new jsPDF('p', 'mm', 'a4', 1);
                                var fileName = getPdfFileName($location);
                                var heightLeft = imgHeight;
                                var position = 0;
                                doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, undefined, 'SLOW');
                                heightLeft -= pageHeight;
                                while (heightLeft >= 0) {
                                    position = heightLeft - imgHeight;
                                    doc.addPage();
                                    doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight, undefined, 'SLOW');
                                    heightLeft -= pageHeight;
                                }
                                doc.save(fileName);
                                ngElement('body').removeClass('pdf-generation');
                                overlay.remove();
                            },
                            proxy: 'compatibilityguide/api/feature/sharing/image',
                        };
                        html2canvas(source, options);
                    }
                    catch (error) {
                        console.info(error);
                        ngElement('body').removeClass('pdf-generation');
                        overlay.remove();
                    }
                });
            });
        };
        return {
            link: function ($scope, $element) {
                $element.on('click', function () { generatePdf($scope); });
                $scope.$on('$destroy', function () { $element.off('click'); });
            },
            restrict: 'A',
        };
    },
];
